/* esm.sh - ieee754@1.2.1 */
export * from "/*ieee754@1.2.1/esnext/ieee754.mjs";
export { default } from "/*ieee754@1.2.1/esnext/ieee754.mjs";
